import IconCheck from "./IconCheck";
import IconAlert from "./IconAlert.js";
import "./KeywordUsage.scss";

const KeywordUsage = function(props) {
	if (!props?.keywordStats.length || !props.words.length) {
		return;
	}
	const {keywordStats, words} = props;
	const keywordUsageTable = keywordStats.map((item, i) => {
		let key = 'keyword' + i;
		let isUsed = words.includes(item.word);
		return props.translations ? (
			<tr key={key}>
				<td>{item.word}</td>
				<td>{item.translation}</td>
				<td>{isUsed ? (<IconCheck/>) : (<IconAlert/>)}</td>
			</tr>
		) :(
			<tr key={key}>
				<td>{item.word}</td>
				<td>{isUsed ? (<IconCheck/>) : (<IconAlert/>)}</td>
			</tr>
		)
	});

	return props.translations ? (
		<div className="keyword-usage">
			<table>
				<thead>
					<tr>
						<th>{window?.t?.KEYWORD}</th>
						<th>{window?.t?.TRANSLATION}</th>
						<th>{window?.t?.USAGE}</th>
					</tr>
				</thead>
				<tbody>
					{keywordUsageTable}
				</tbody>
			</table>
		</div>
	) : (
		<div className="keyword-usage">
			<table>
				<thead>
					<tr>
						<th>{window?.t?.KEYWORD}</th>
						<th>{window?.t?.USAGE}</th>
					</tr>
				</thead>
				<tbody>
					{keywordUsageTable}
				</tbody>
			</table>
		</div>
	)
};

export default KeywordUsage;